"use strict";
/**
 * @module "ethpm/session"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = exports.Builder = void 0;
const config = __importStar(require("../config"));
const query_1 = require("./query");
class Builder {
    constructor(config_) {
        this.connectors = Object.assign({}, ...Object.keys(config_)
            .map((service) => ({
            [service]: config.load(config_[service]),
        })));
    }
    connect(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = Object.assign({}, ...yield Promise.all(Object.keys(this.connectors).map((service) => __awaiter(this, void 0, void 0, function* () {
                return ({
                    [service]: yield this.connectors[service].connect(options),
                });
            }))));
            return new Session(workspace);
        });
    }
}
exports.Builder = Builder;
class Session {
    constructor(workspace) {
        this.workspace = workspace;
    }
    query(package_) {
        return new query_1.Query({
            package: package_,
            workspace: this.workspace,
        });
    }
    get manifests() {
        if ('manifests' in this.workspace) {
            return this.workspace.manifests;
        }
        throw new Error('No manifests');
    }
    get storage() {
        if ('storage' in this.workspace) {
            return this.workspace.storage;
        }
        throw new Error('No storage');
    }
    get installer() {
        if ('installer' in this.workspace) {
            return this.workspace.installer;
        }
        throw new Error('No installer');
    }
    get registries() {
        if ('registries' in this.workspace) {
            return this.workspace.registries;
        }
        throw new Error('No registries');
    }
}
exports.Session = Session;
